import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeCodeState } from '~/types';
import { TypeErrorFormat, requestHelper } from '~/utils';

export type TypeGetMonthlyWorkPlanResponse = {
  code: string;
  message: string;
  data: {
    year: string;
    month: string;
    records: TypeMonthlyWorkPlanDaily[];
  };
};

export type TypeMonthlyWorkPlanDaily = {
  workDate: string;
  /**
   * 근무 등록 요청 상태
   * - PENDING(대기)
   * - APPROVED(승인)
   * - REJECTED(거절)
   */
  status: TypeCodeState;
  decisionReason: string | null;
  cluster: TypeCodeState;
  center: TypeCodeState;
  workPart: TypeCodeState;
  workShift: {
    startTime: string;
    endTime: string;
    isStartTimeBeforeEndTime: boolean;
    formattedText: string;
  };
};

/** @description 월별 근무 등록 요청 현황 조회 */
export const useGetMonthlyWorkPlan = () => {
  const queryClient = useQueryClient();

  const requestGetMonthlyWorkPlan = async ({
    yearMonth,
    onSuccess,
    onError,
    showLoading = false,
  }: {
    yearMonth: string;
    onSuccess: (response: TypeGetMonthlyWorkPlanResponse) => void;
    onError: (error: TypeErrorFormat) => void;
    showLoading?: boolean;
  }) => {
    const endpoint = '/work-plan-registration-requests/monthly';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetMonthlyWorkPlanResponse>>({
      queryKey: ['monthly-work-plan', yearMonth],
      queryFn: () => axiosInstance.get(endpoint, { params: { yearMonth } }),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError, undefined, { showLoading });
  };

  return requestGetMonthlyWorkPlan;
};
